import * as preact from "preact";

import * as modalController from "modalController";
import EditCardView from "views/EditCardView";

interface Options {
  title?: string;
  newCard?: boolean;
  savedCallback?: () => void;
  doneCallback?: () => void;
  /** Covers the screen (phones) */
  fullScreen?: boolean;
  /** Shown above the card */
  header?: preact.ComponentChild;
  /** Beside the word's field, where nothing else plays it */
  playButton?: boolean;
}

export const show = (userWord, options: Options) => {
  let unsavedChanges = false;

  modalController.show(
    <div id="editCardDialog">
      {options.header}
      <EditCardView
        userWord={userWord}
        options={{ ...options, doneButton: !options.newCard }}
        phrase={/ /.test(userWord.state.value.word)}
        doneCallback={() => {
          // Cancel modal dialog upon save
          modalController.cancel();
          options.doneCallback?.();
        }}
        savedCallback={() => {
          options.savedCallback?.();
        }}
      />
    </div>,
    {
      title: options.title,
      fullScreen: options.fullScreen,
      confirmCancelCallback: function () {
        return (
          !unsavedChanges ||
          confirm("You have unsaved changes. Are you sure you want to close?")
        );
      },
      onShow: function () {
        const editCardDialog = document.getElementById("editCardDialog");
        const wordInput =
          editCardDialog?.querySelector<HTMLInputElement>('input[name="word"]');
        const translateInput = editCardDialog?.querySelector<HTMLInputElement>(
          'input[name="translation"]'
        );

        if (wordInput?.value === "") {
          wordInput.focus();
        } else if (translateInput?.value === "") {
          translateInput.focus();
        }
      },
    }
  );
};
